// This component is no longer needed since we're using localStorage only for analytics
export const cookieConsentGiven = () => 'yes';

export function Banner() {
  return null;
}